<template>
  <div
    class="c-goto-btn"
    v-view="viewHandler"
    :class="[animate ? animationClass : '']"
  >
    <a :href="`${anchor}`" @click.prevent="goto">
      <i class="fas fa-angle-down"></i>
    </a>
  </div>
</template>

<script>
import SmoothScroll from "smooth-scroll/dist/smooth-scroll.polyfills.min.js"

const scroll = new SmoothScroll()

export default {
  name: "GoToBtn",
  props: {
    animationClass: {
      type: String,
      default: "bounce-down"
    },
    anchor: {
      type: String
    }
  },
  data() {
    return {
      animate: true
    }
  },
  methods: {
    goto() {
      this.$nextTick(() => {
        const selector = document.querySelector(this.anchor)

        scroll.animateScroll(selector, null, {
          offset: 50,
          speed: 700,
          updateURL: false,
          popstate: false
        })
      })
    },
    viewHandler(e) {
      if (e.percentTop < 0.7) {
        // 0..1 position of element at viewport 0 - above , 1 - below
        this.animate = false
      }
    }
  }
}
</script>
